import * as React from 'react';

import ModalHandlerV2 from '../v2/handler/FacebookButtonModalHandler';

import type {
  FacebookButtonState
} from 'components/external-integration/facebook/button/types';

interface Props {
  creatorProfileId: number,
  buttonState: FacebookButtonState
}

const FacebookButtonModalManager: React.FC<Props> = ({
  creatorProfileId,
  buttonState
}) => (
  <div className="facebook-button-manager">
    <ModalHandlerV2
      creatorProfileId={creatorProfileId}
      buttonState={buttonState}
    />
  </div>
);

export default FacebookButtonModalManager;
